import { Injectable } from '@angular/core';
import { ChooseComponent } from "../../components/pop-up-component/choose/choose.component";
import { Observable, of, Subject, Subscription } from "rxjs";
import {
    SelectWithChipsComponent
} from "../../components/pop-up-component/select-with-chips/select-with-chips.component";
import { aggregateHardawareDetailDevice, arrayIsSet, ElementTreeType, KeyStringValue } from "./global-variables.service";
import { SetThermostatComponent } from "../../components/pop-up-component/set-thermostat/set-thermostat.component";
import { debounceTime, distinctUntilChanged, map } from "rxjs/operators";
import { ElementParse, ElementParse_v2 } from "../../ParseClass/Element.Parse";
import {
    AutocompleteUpdateElementValueType,
    UpdateElementComponent
} from "../../components/pop-up-component/update-element/update-element.component";
import {
    UpdateIotDeviceComponent
} from "../../components/pop-up-component/update-iot-device/update-iot-device.component";
import { IotDevicesParse } from "../../ParseClass/Iotdevices.Parse";
import { htmlData } from "../../pages/management-elements/elements-page/elements-page.component";
import { UntypedFormGroup } from "@angular/forms";
import {
    FormByHtmlDataObjFormComponent
} from "../../components/pop-up-component/form-by-html-data-obj-form/form-by-html-data-obj-form.component";
import {
    ChartDataTypesComponent,
} from "../../components/pop-up-component/chart-data-types/chart-data-types.component";
import { SelectDateComponent } from "../../components/pop-up-component/select-date/select-date.component";
import { ShowRawDetailComponent } from "../../components/pop-up-component/show-raw-detail/show-raw-detail.component";
import { ElementTypeParse } from "../../ParseClass/ElementType.Parse";
import { SearchPointComponent } from "../../components/pop-up-component/search-point/search-point.component";
import { GeoPoint } from "parse";
import { SensorEventParse } from "../../ParseClass/SensorEvent.Parse";
import {
    SensorEventFormComponent
} from "../../components/pop-up-component/sensor-event-form/sensor-event-form.component";
import { IoTDeviceConfigurationParse2 } from "../../ParseClass/IoTDeviceConfiguration.Parse";
import { DevicesDividedForCategory } from "./sensor-event-page.service";
import {
    ResponseSensorList,
    SensorsListComponent
} from "../../components/pop-up-component/sensors-list/sensors-list.component";
import { EnvironmentElement } from "../../ParseClass/environment-element";
import {
    NotificationsDetailsComponent
} from "../../components/pop-up-component/notifications-details/notifications-details.component";
import { NotificationParse } from "../../ParseClass/notificationParse";
import { SensorDataTypesParse } from "../../ParseClass/sensor-data-types-parse";
import { MatDialog } from "@angular/material/dialog";
import { NotificationStates } from "./notifications.service";
import { rangeDate } from "./all-devices.service";
import { dataForm } from "../../widget/auto-complete-form/auto-complete-form.component";
import { CalendarEvent } from "../../ParseClass/calendar-event";
import { SensorModelParse } from "../../ParseClass/SensorModel.Parse";
import { MultipleActionsComponent, MultipleActionsData } from 'src/app/components/pop-up-component/multiple-actions/multiple-actions.component';


export type TypeSelectChipsDialog = {
    traductionKey: string,
    type: string,
    id: string,
}
export type ActionsButtons = {
    action: string,
    icon?: string,
    disabled?: boolean,
    iconSvg?: string,
    color: string,
    traductionKey?: string,
}

@Injectable({
    providedIn: 'root'
})
export class OpenDialogService {

    constructor(private dialog: MatDialog,) {
    }

    public openDialogForDelete(messages: string[]) {
        const dialogRef = this.dialog.open(ChooseComponent, {
            width: '340px',
            minHeight: '200px',
            data: { messages: messages },
            autoFocus: false,
            exitAnimationDuration: 0.1
        });
        return dialogRef.afterClosed();
    }

    public openDialogNotification(notification: NotificationParse, users: string[] | undefined, isEditable: boolean | undefined): Observable<{
        markHasRead: boolean,
        state?: NotificationStates,
        userId?: any
    } | undefined> {
        const dialogRef = this.dialog.open(NotificationsDetailsComponent, {
            width: '600px',
            maxWidth: '100%',
            data: { notification, users, isEditable },
            autoFocus: false,
            exitAnimationDuration: 0.1
        });
        return dialogRef.afterClosed();
    }

    public openDialogSelectChips(slideValues: TypeSelectChipsDialog[] = [], chips: TypeSelectChipsDialog[] = [], multipleValue = false, chipsDisabled: any = undefined, css: any = { chipsClass: { size: 'chips-size-M' } }, initialSlideId: string | undefined = undefined, initialChipIds: string[] | undefined = undefined): Observable<{
        selectedChips: TypeSelectChipsDialog[],
        slidesValue: TypeSelectChipsDialog
    }> {
        const dialogRef = this.dialog.open(SelectWithChipsComponent, {
            width: '340px',
            minHeight: '200px',
            data: { slideValues, chips, css, chipsDisabled, multipleValue, initialSlideId, initialChipIds },
            autoFocus: false,
            exitAnimationDuration: 0.1
        });
        return dialogRef.afterClosed();
    }


    public liveEmitValue(device: aggregateHardawareDetailDevice, visualization: any | undefined = undefined, minMax: {
        [key: string]: { min: number, max: number }
    } | undefined = undefined, saving$: Subject<any> | undefined = undefined): Observable<any> {
        return new Observable((subscriber => {
            const dialogRef = this.dialog.open(SetThermostatComponent, {
                width: '400px',
                maxWidth: '100vw',
                minHeight: '200px',
                panelClass: 'custom-dialog-container',
                data: { device: device, visualization, minMax, saving$ }
            });
            const subs: Subscription[] = [];
            const keys = dialogRef.componentInstance.keysForm;
            keys.forEach(key => {
                const sub = dialogRef.componentInstance.form.get(key)?.valueChanges.pipe(
                    debounceTime(600),
                    distinctUntilChanged()
                ).subscribe(value => {
                    const objSave: any = {};
                    objSave[key] = true;
                    const objValue: any = {}
                    objValue[key] = value;
                    saving$?.next(objSave)
                    subscriber.next(objValue);
                })
                if (sub instanceof Subscription) {
                    subs.push(sub);
                }
            })

            dialogRef.afterClosed().subscribe(value => {
                subs.forEach(sub => sub.unsubscribe());
                subscriber.next(value);
                subscriber.complete();
                subscriber.unsubscribe();
            });
        }))

    }


    public openDialogHeatPumpConfiguration(htmlData: htmlData[], form: UntypedFormGroup, liveEmitKeys: string[], updateCommand: Subject<{
        [key: string]: boolean
    }>): Observable<{ values: any, finished: boolean }> {
        return new Observable<any>(subscriber => {
            const subscriptions: Subscription[] = [];
            const sub = updateCommand.asObservable().subscribe(val => {
                Object.keys(val).forEach(key => {
                    if (form.get(key)) {
                        if (!val[key]) {
                            form.get(key)?.enable({ emitEvent: false });
                        } else {
                            form.get(key)?.disable({ emitEvent: false });
                            form.get(key)?.markAsPristine();
                            form.get(key)?.markAsUntouched();
                        }
                    }
                });
            });
            subscriptions.push(sub);
            let minWidth = '100vw';
            let resizeClass = 'resize';
            if (arrayIsSet(htmlData)) {
                const index = htmlData.findIndex(
                    a => a.forms.length > 3
                )
                if (index >= 0) {
                    minWidth = '100vw';
                    resizeClass = 'resize';
                } else if (window.innerWidth < 500) {
                    minWidth = '100%';
                    resizeClass = '';
                } else {
                    minWidth = '500px';
                    resizeClass = '';
                }
            }
            const dialogRef = this.dialog.open(FormByHtmlDataObjFormComponent, {
                minWidth: minWidth,
                panelClass: 'huna-height-panel',
                data: { htmlData, form, resizeClass: resizeClass },
                autoFocus: false,
                exitAnimationDuration: 0.1
            });
            liveEmitKeys.forEach(key => {
                if (form.get(key) != null) {
                    const sub = form.get(key)?.valueChanges.subscribe(val => {
                        const objSave: any = {};
                        objSave[key] = true;
                        updateCommand.next(objSave)
                        const obj: any = {};
                        obj[key] = val
                        subscriber.next({ values: obj, finished: false })
                    });
                    if (sub != null) {
                        subscriptions.push(sub);
                    }
                }
            });
            dialogRef.afterClosed()
                .pipe(
                    map((formHtml) => {
                        if (formHtml != null) {
                            const values: any = {};
                            Object.keys(formHtml.value).forEach(key => {
                                if (formHtml.get(key)?.dirty && !liveEmitKeys.includes(key) && formHtml.value[key] != null) {
                                    values[key] = formHtml.value[key];
                                }
                            }
                            );
                            return { values: values, finished: true };
                        } else {
                            return { values: undefined, finished: true }
                        }
                    })
                )
                .subscribe(value => {
                    subscriptions.forEach(sub => sub.unsubscribe());
                    subscriber.next(value);
                    subscriber.complete();
                    subscriber.unsubscribe();
                }, error => {
                    subscriptions.forEach(sub => sub.unsubscribe());
                    subscriber.error(error);
                    subscriber.complete();
                    subscriber.unsubscribe();
                });


        })


    }

    openFormBatchEditElement(currentValues: any): Observable<any> {
        // const dialogRef = this.dialog.open(FormByHtmlDataObjFormComponent, {
        //     panelClass: 'huna-height-panel',
        //     data: {htmlData, form},
        //     autoFocus: false,
        //     exitAnimationDuration:0.1
        // });
        return of()
    }

    // public openDialogChartTemperature(device: aggregateHardawareDetailDevice): Observable<any> {
    //     const dialogRef = this.dialog.open(TemperatureDetailsChartComponent, {
    //         minWidth: '100vw',
    //         height: '100vh',
    //         data: {device}
    //     });
    //     return dialogRef.afterClosed();
    // }


    public openDialogChartSensorDataTypes(device: aggregateHardawareDetailDevice, projectName: string, type: ElementTypeParse | undefined, selectElement: ElementTreeType | undefined, elements: ElementTreeType[] | undefined = undefined, selectSensorData: string[] | undefined = undefined, range: rangeDate | undefined = undefined): Observable<any> {
        const dialogRef = this.dialog.open(ChartDataTypesComponent, {
            minWidth: '100vw',
            height: '100vh',
            data: { device, projectName, elementType: type, selectElement, elements, selectSensorData, range: range },
            autoFocus: false,
            exitAnimationDuration: 0.1
        });
        return dialogRef.afterClosed();
    }

    public openDialogUpdateElment(element: ElementParse | ElementParse_v2, disableForm: boolean,
        possibleValuesPointer: { [k: string]: any[] } | undefined,
        possibleValuesExisistingField: AutocompleteUpdateElementValueType | undefined,
        isBatchEdit: boolean = false,
        title: string | undefined = undefined
    ): Observable<any> {
        const dialogRef = this.dialog.open(UpdateElementComponent, {
            width: '500px',
            maxWidth: '100%',
            panelClass: 'huna-height-panel',
            data: { element, disableForm, possibleValuesPointer, possibleValuesExisistingField, isBatchEdit, title },
            autoFocus: false,
            exitAnimationDuration: 0.1
        });
        return dialogRef.afterClosed();
    }

    public openDialogUpdateIotDevice(iotdevice: IotDevicesParse, disableFormFields: string[] | undefined, possibleValuesPointer: {
        [k: string]: any[]
    } | undefined, sensorDataTypes: SensorDataTypesParse[] | undefined, sensorDataModels: SensorModelParse[] | undefined,
    ): Observable<any> {
        const dialogRef = this.dialog.open(UpdateIotDeviceComponent, {
            width: '500px',
            maxWidth: '100%',
            panelClass: 'huna-height-panel',
            data: { iotdevice, disableFormFields, possibleValuesPointer, sensorDataTypes, sensorDataModels },
            autoFocus: false,
            exitAnimationDuration: 0.1
        });
        return dialogRef.afterClosed();
    }


    openSelectdate(title: string, maxDate: Date, buttons: {
        action: any,
        icon?: string,
        color?: string,
        text?: string
    }[] | undefined = undefined): Observable<{ end: Date, start: Date, action?: any } | undefined> {

        const dialogRef = this.dialog.open(SelectDateComponent, {
            minWidth: '500px',
            panelClass: 'huna-height-panel',
            data: { title, maxDate, buttons },
            autoFocus: false,
            exitAnimationDuration: 0.1
        });
        return dialogRef.afterClosed();
    }

    openShowRawDetail(values: {
        title: { traduction?: string, value?: any },
        subTitle?: { traduction?: string, value?: any },
        value: { traduction?: string, value?: any }
    }[],
        generalTitle: string | undefined = undefined,
        removeValues = false,
        subTitle: string | undefined = undefined,
        actions: ActionsButtons[] | undefined = undefined
    ): Observable<undefined | {
        values?: {
            title: { traduction?: string, value?: any },
            value: { traduction?: string, value?: any }
        }[]
        action?: ActionsButtons
    }> {
        let resizeClass;
        let minWidth = '100vw';
        if (values.length > 4) {
            minWidth = '100vw';
            resizeClass = 'resize';
        } else if (window.innerWidth < 500) {
            minWidth = '100%';
            resizeClass = '';
        } else {
            minWidth = '500px';
            resizeClass = '';
        }
        const dialogRef = this.dialog.open(ShowRawDetailComponent, {
            maxHeight: '100vh',
            minWidth,
            panelClass: 'huna-height-panel',
            data: { values, resizeClass, title: generalTitle, removeValues, actions, subTitle },
            autoFocus: false,
            exitAnimationDuration: 0.1
        });
        return dialogRef.afterClosed()
    }

    openEditSensorEvent(values: {
        sensorEvent?: SensorEventParse,
        elements?: ElementParse[],
        calendars?: CalendarEvent[],
        elementsType?: ElementTypeParse[],
        elementsCategory?: DevicesDividedForCategory,
        users?: any,
        sensorDataType?: dataForm[]

    }, isEditable: boolean | undefined): Observable<any | undefined> {
        const dialogRef = this.dialog.open(SensorEventFormComponent, {
            maxWidth: 'calc(100vh - 30px)',
            maxHeight: 'calc(100vh - 30px)',
            minHeight: 'calc(100vh - 30px)',
            width: '100%',
            data: { ...values, isEditable },
            autoFocus: false,
            exitAnimationDuration: 0.1
        });
        return dialogRef.afterClosed();
    }

    openSearchPoint(center: GeoPoint | undefined): Observable<{ point: google.maps.LatLng }> {
        const dialogRef = this.dialog.open(SearchPointComponent, {
            maxWidth: '100vw',
            maxHeight: '100vh',
            height: '100%',
            width: '100%',
            data: { center },
            autoFocus: false,
            exitAnimationDuration: 0.1
        });
        return dialogRef.afterClosed();
    }


    openSensorslist(name: string, energyElement: EnvironmentElement, elements: ElementTreeType[] | undefined, isEditable: boolean | undefined): Observable<undefined | ResponseSensorList> {
        const dialogRef = this.dialog.open(SensorsListComponent, {
            data: { name, energyElement, elements, isEditable },

            autoFocus: false,
            exitAnimationDuration: 0.1
        });
        return dialogRef.afterClosed();
    }
    openSelectMultipleActions(data: MultipleActionsData): Observable<undefined | ActionsButtons[]> {
        const dialogRef = this.dialog.open(MultipleActionsComponent, {
            width: '400px',
            data,
            autoFocus: false,
            exitAnimationDuration: 0.1
        });
        return dialogRef.afterClosed();
    }
}
